import { render, staticRenderFns } from "./TabVisibility.vue?vue&type=template&id=dafbe18a&"
import script from "./TabVisibility.vue?vue&type=script&lang=js&"
export * from "./TabVisibility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports